module.exports = __webpack_public_path__ + "static/media/home-outlined.12994327.svg";